module.exports = __webpack_public_path__ + "assets/img/gbApp.9602faf2.png";